import feedback from './feedback.json';
import flags from './flags.json';
import legal from './legal.json';
import prompts from './prompts.json';

const messages = {
  feedback,
  flags,
  legal,
  prompts,
};

export default messages;
